import { ReactElement } from 'react';
import Modal from '@components/Modal';
import { getLabelFallback } from '@utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '@redux-actions/';

const GenericErrorModal = () : ReactElement => {
    const dispatch = useDispatch();

    const close = () => {
        dispatch(actions.setGenericErrorModal(false, ''));
    }

    const modalErrorText = useSelector(state => state.cart.modalErrorText)

    return(
        <div className="generic-error-modal">
            <Modal close={close}>
                <div className="generic-error-modal-content">
                    <h2 className="generic-error-modal-content-title">{ getLabelFallback('GENERIC_ERROR_MODAL_TITLE') }</h2>
                    <div className="generic-error-modal-content-text">
                        <span>{ modalErrorText }</span>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default GenericErrorModal;